module.exports = __webpack_public_path__ + "b5ba604f77f89ee0efe5324c5aa7d4d0.jpg";